const srvValidator = (value) => {
  if (!value) return "validate.srv_empty";

  return true;
};

export { srvValidator };
